import React, { useEffect, useState } from 'react';
import { Routes as RouterRoutes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { AUTHENTICATED_AMMINISTRAZIONE_ENTRY, AUTHENTICATED_CONTABILITA_ENTRY, AUTHENTICATED_ENTRY, LIST_ROLE_CENTRO_CONTABILE, LIST_ROLE_CENTRO_MEDICO } from 'configs/AppConfig';
import { publicRoutes, roleRoutesUtility } from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import AppRoute from './AppRoute';
import { useDispatch, useSelector } from 'react-redux';
import Loading from 'components/shared-components/Loading';
import { disableRefreshRotte } from 'store/slices/authSlice';

const Routes = () => {

	const { ruolo, centro_in_uso, inizializza_rotte } = useSelector(state => state.auth);
	const [protectedRoutes, setProtectedRoutes] = useState([]);
	const [isLoading, setIsLoading] = useState(true); // Stato di caricamento
	const [entryRoute, setEntryRoute] = useState(''); // Stato di caricamento
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

	const valorizzateRotte = () => {

		const myRoutes = roleRoutesUtility(centro_in_uso, ruolo.name);
		console.log("myRoutes", myRoutes);


		setProtectedRoutes(myRoutes);
		// Imposta isLoading a false solo dopo aver caricato tutte le rotte
		setTimeout(() => {
			setIsLoading(false);
		}, 100); // Aggiunge un piccolo ritardo per assicurarsi che le rotte siano completamente caricate

	}

	useEffect(() => {
		setIsLoading(true);
		console.log("inizializza_rotte", inizializza_rotte);

		if (ruolo) {
			let valueEntry = "";
			if (inizializza_rotte) {

				console.log("ruolo.name", ruolo.name);

				valueEntry = AUTHENTICATED_ENTRY;

				if (ruolo && ruolo.name === 'contabile') {
					valueEntry = AUTHENTICATED_CONTABILITA_ENTRY;
				} else {
					if (centro_in_uso === 'centro_contabile') {
						valueEntry = AUTHENTICATED_CONTABILITA_ENTRY;
						navigate(AUTHENTICATED_CONTABILITA_ENTRY)
					} else if (centro_in_uso === 'centro_medico') {
						valueEntry = AUTHENTICATED_ENTRY;
						navigate(AUTHENTICATED_ENTRY)
					} else if (centro_in_uso === 'centro_amministrativo') {
						valueEntry = AUTHENTICATED_AMMINISTRAZIONE_ENTRY;
						navigate(AUTHENTICATED_AMMINISTRAZIONE_ENTRY)
					}
				}
				dispatch(disableRefreshRotte())

				console.log("valueEntry", valueEntry)
				setEntryRoute(valueEntry);
				valorizzateRotte();
			} else {
				console.log(location.pathname)
				if (location.pathname === "/") {
					if (centro_in_uso === 'centro_contabile') {
						valueEntry = AUTHENTICATED_CONTABILITA_ENTRY;
						navigate(AUTHENTICATED_CONTABILITA_ENTRY)
					} else if (centro_in_uso === 'centro_medico') {
						valueEntry = AUTHENTICATED_ENTRY;
						navigate(AUTHENTICATED_ENTRY)
					} else if (centro_in_uso === 'centro_amministrativo') {
						valueEntry = AUTHENTICATED_AMMINISTRAZIONE_ENTRY;
						navigate(AUTHENTICATED_AMMINISTRAZIONE_ENTRY)
					}
				} else {
					valorizzateRotte();
				}
			}


		} else {
			setIsLoading(false);
		}

	}, [centro_in_uso]);

	if (isLoading) {
		return <Loading cover="content" text={"Caricamento pagina.."} />;
	}



	return (
		<RouterRoutes>
			<Route path="/" element={<ProtectedRoute />}>
				{/* Assicurarsi che entryRoute sia impostato prima di reindirizzare */}
				<Route path="/" element={isLoading ? <Loading cover="content" text={"Caricamento rotte.."} /> : <Navigate replace to={entryRoute} />} />
				{isLoading ? <Loading cover="content" text={"Caricamento rotte.."} /> : protectedRoutes.map((route, index) => {
					return (
						<Route
							key={route.key + index}
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key}
									component={route.component}
									{...route.meta}
								/>
							}
						/>
					);
				})}
				{isLoading ? <Loading cover="content" text={"Caricamento rotte.."} /> : <Route path="*" element={<Navigate to="/not-found" replace />} />}

			</Route>
			<Route path="/" element={isLoading ? <Loading cover="content" text={"Caricamento rotte.."} /> : <PublicRoute />} >

				{isLoading ? <Loading cover="content" text={"Caricamento rotte.."} /> : publicRoutes.map((route) => {
					return (
						<Route
							key={route.path}
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key}
									component={route.component}
									{...route.meta}
								/>
							}
						/>
					);
				})}
			</Route>
		</RouterRoutes >

	);
};

export default Routes;
